import L from "leaflet"
import { LocateControl } from "leaflet.locatecontrol"
import { MapConfig } from "./map_config.js"

export class LocationHandler {
  constructor(map) {
    this.map = map;
    this.locateControl = null;
  }

  setupLocationControl() {
    // Create custom locate control
    L.Control.Locator = LocateControl.extend({
      _drawMarker: function () {
        LocateControl.prototype._drawMarker.call(this);
      },
      options: MapConfig.getLocateControlOptions()
    });
    
    this.locateControl = new L.Control.Locator(MapConfig.getLocateControlOptions()).addTo(this.map);

    this.setupLocationEvents();
    this.locateControl.start();
  }

  setupLocationEvents() {
    this.map.on("locationfound", function(e) {
      const acc = Math.round(e.accuracy);
      const accuracyLabel = document.getElementById("accuracy-label");
      if (accuracyLabel) {
        accuracyLabel.textContent = `Točnost: ±${acc} m`;
      }
      this.setView(e.latlng, 14);
    });

    this.map.on("locationerror", function() {
      const accuracyLabel = document.getElementById("accuracy-label");
      if (accuracyLabel) {
        accuracyLabel.textContent = "Greška prilikom lociranja";
      }
    });
  }
}
